import { useEffect, useState } from "react";
import TextInputElementComponent from "../../../elements/inputElements/TextInputElementComponent";
import textInputModel from "../../../../models/elements/inputElements/textInput.model";
import TableElementComponent from "../../../elements/TableElementComponent";
import useWebsiteConfiguration from "../../../../hooks/websiteConfigurations/useWebsiteConfiguration";
import { websiteConfigurationEnum } from "../../../../enums/websiteConfigurations/websiteConfiguration.enum";
import { useDispatch } from "react-redux";


export const WebsiteConfigurationDeliveryOptionsSection = ({ props }) => {
  const dispatch = useDispatch();
  const { currentValue, handleChange, handleUpdateConfiguration } = props;
  const [errors, setErrors] = useState({});

  const { configurationValue: deliveryOptions } = useWebsiteConfiguration(websiteConfigurationEnum.DeliveryOptions);

  const getIdInputElement = () => {
    const inputProps = {
      ...textInputModel,
      name: "id",
      error: errors.id,
      value: currentValue.id,
      onChange: handleChange,
      label: "מזהה משלוח (מספר/טקסט)",
    };
    return <TextInputElementComponent props={inputProps} />;
  };

  const getDescriptionInputElement = () => {
    const inputProps = {
      ...textInputModel,
      name: "description",
      error: errors.description,
      value: currentValue.description,
      onChange: handleChange,
      label: "תיאור",
    };
    return <TextInputElementComponent props={inputProps} />;
  };

  const getPriceInputElement = () => {
    const inputProps = {
      ...textInputModel,
      name: "price",
      error: errors.price,
      value: currentValue.price,
      onChange: handleChange,
      label: "מחיר",
      type: "number",
    };
    return <TextInputElementComponent props={inputProps} />;
  };

  const getAddDeliveryOptionSectionElement = () => {
    return (
      <section className="deliveryOptionInputsContainer">
        {getIdInputElement()}
        {getDescriptionInputElement()}
        {getPriceInputElement()}
      </section>
    );
  };

  const handleDeleteDeliveryOption = async (deliveryOptionId) => {
    const updatedOptions = deliveryOptions.filter((option) => option.id !== deliveryOptionId);
    const request = {
      key: websiteConfigurationEnum.DeliveryOptions,
      value: JSON.stringify(updatedOptions),
    };
    handleUpdateConfiguration(request);
  };

  const getDeliveryOptionTableElement = () => {
    const columns = [
      { label: "מזהה משלוח", field: "id" },
      { label: "תיאור", field: "description" },
      { label: "מחיר", field: "price" },
    ];

    const actions = [
      {
        label: "מחיקת קטגוריה",
        icon: "fa-solid fa-trash",
        className: "redButton",
        onClick: (option) => handleDeleteDeliveryOption(option.id),
      },
    ];

    return <TableElementComponent columns={columns} data={deliveryOptions} actions={actions} />;
  };

  return (
    <div className="manageDeliveryOptionsContainer">
      {getAddDeliveryOptionSectionElement()}
      {getDeliveryOptionTableElement()}
    </div>
  );
};

export default WebsiteConfigurationDeliveryOptionsSection;
